import { OpenInNewOutlined } from "@mui/icons-material";
import React, { useState, useEffect } from "react";
import ReactMarkdown from "react-markdown";
import { API } from "aws-amplify";
import * as queries from "../../graphql/queries";
import fetchSearchItemsNextToken from "../../graphql/fetchSearchItemsNextToken";

const Courses = ({
  text,
  speed = 1,
  setContainerScrollDown,
  role,
  courseRecommendations,
  thirdPartyMatches, 
  setShowLoader,
}) => {

  const [displayedText, setDisplayedText] = useState(
    role === "user" || speed === -1 ? text : ""
  );
  const [isTypingFinished, setIsTypingFinished] = useState(
    role === "user" || speed === -1
  );

  // Moodle Course Direct Enrollment Functions
  const handleTakeCourseClick = async (courseId) => {
    try {
      setShowLoader(true);
      // console.log("courseId", courseId);
      // setShowLoader(true);
      const userEmail = localStorage.getItem("email");
      const userProfileDetailsId = localStorage.getItem("userDetailsID");

      const userProfileDetails = await fetchSearchItemsNextToken({
        query: queries.searchUserProfileDetails,
        variables: { limit: 100, filter: { id: { eq: userProfileDetailsId } } },
      });

      const bodyData = {
        email: userEmail,
        first_name: userProfileDetails[0].first_name,
        last_name: userProfileDetails[0].last_name,
        username: userProfileDetails[0].username,
        courseId: parseInt(courseId),
      };

      // const response = await axios.post(
      //   `https://0oemy34wii.execute-api.ap-south-1.amazonaws.com/enrolment`,
      //   bodyData
      // );

      // For now the Role assigned is non-editing teacher
      const apiName = "moodlecourseenrol";
      const path = "/moodle-enrol";
      const postData = {
        body: {
          email: userEmail,
          first_name: userProfileDetails[0].first_name,
          last_name: userProfileDetails[0].last_name,
          username: userProfileDetails[0].username,
          courseId: parseInt(courseId),
          // courseId: 259, // Just for testing purposes.
        },
      };

      const response = await API.post(apiName, path, postData);
      // console.log("response", response);

      if (response.loginUrl && response.loginUrl !== "") {
        // open the link in a new window
        window.open(response.loginUrl, "_blank");
        // window.location.replace(response.loginUrl);
      } else {
        // setShowLoader(false);
      }

    } catch (error) {
      console.log("error", error);
    } finally {
      setShowLoader(false);
    }
  };

  useEffect(() => {
    if (role === "user" || speed === -1) return;
    let intervalId;
    const writeText = () => {
      if (displayedText.length < text.length) {
        setDisplayedText(text.substring(0, displayedText.length + 1));
        setContainerScrollDown(Date.now());
      } else {
        clearInterval(intervalId);
        setIsTypingFinished(true);
      }
    };

    intervalId = setInterval(writeText, speed);

    return () => clearInterval(intervalId);
  }, [displayedText]);

  return (
    <>
    <ReactMarkdown>
      {displayedText}
    </ReactMarkdown>
    <>
    {isTypingFinished && courseRecommendations && courseRecommendations.length > 0 && (
        <div className="recommendations" style={{
          borderTop: '1px solid #f1f1f1',
          borderRadius: '5px',
          borderEndEndRadius: "12px",
          padding: '10px',
          marginTop: '10px',
          backgroundColor: '#f9f9f9',
          boxShadow: 'inset 0 0 5px 5px #f3f3f3'
        }}>
          <h3 className="recommendation-header" style={{
            margin: 0,
            padding: 0,
            fontSize: '0.8rem',
            marginBottom: '10px'
          }}>Course Recommendations</h3>
          <ul style={{
            listStyleType: 'none',
            padding: 0,
            margin: 0
          }} >
            {courseRecommendations.map((recommendation, index) => (
              <li key={index} style={{
                padding: '10px',
                borderTop: '1px solid #dedede',
                display: 'flex',
                justifyContent: 'space-between'
              }}>
                <div className="recommendation-box" style={{
                  display: 'flex',
                  alignItems: 'center',
                  width: '100%',
                }} >
                  <div className="description-wrapper" style={{
                    width: '90%',
                    flex: 1,
                    fontSize: '0.8rem',
                    marginRight: '10px'
                  }}>
                    <div className="recommendation-title">
                      <span style={{ fontWeight: 'bold' }}>{recommendation.metadata.title}</span>
                    </div>
                    <div className="recommendation-description">
                      {recommendation.metadata.description}
                    </div>
                  </div>
                  <a
                    className="recommendation-icon"
                    // href={`https://devstemclip.mysphere.net/course/view.php?id=${recommendation.id}`}
                    target="_blank"
                    style={{
                      textDecoration: 'none',
                      color: 'teal',
                      width: "10%",
                      height: '100%',
                      display: 'flex',
                      justifyContent: 'end',
                      alignItems: 'center'
                    }}
                    onClick={() => handleTakeCourseClick(recommendation.id)}
                  >
                    <OpenInNewOutlined className="recommendation-icon" style={{
                      color: 'teal',
                      backgroundColor: '#D9E7E8',
                      borderRadius: '7px',
                      padding: '5px'
                    }} />
                  </a>
                </div>
              </li>
            ))}
          </ul>
        </div>
      )}
      {/* Repeat */}
      {isTypingFinished && thirdPartyMatches && thirdPartyMatches.length > 0 && (
        <div className="recommendations" style={{
          borderTop: '1px solid #f1f1f1',
          borderRadius: '5px',
          borderEndEndRadius: "12px",
          padding: '10px',
          marginTop: '10px',
          backgroundColor: '#f9f9f9',
          boxShadow: 'inset 0 0 5px 5px #f3f3f3'
        }}>
          <h3 className="recommendation-header" style={{
            margin: 0,
            padding: 0,
            fontSize: '0.8rem',
            marginBottom: '10px'
          }}>Harvard Courses Recommendations</h3>
          <ul style={{
            listStyleType: 'none',
            padding: 0,
            margin: 0
          }} >
            {thirdPartyMatches.map((recommendation, index) => (
              <li key={index} style={{
                padding: '10px',
                borderTop: '1px solid #dedede',
                display: 'flex',
                justifyContent: 'space-between'
              }}>
                <div className="recommendation-box" style={{
                  display: 'flex',
                  alignItems: 'center',
                  width: '100%',
                }} >
                  <div className="description-wrapper" style={{
                    width: '90%',
                    flex: 1,
                    fontSize: '0.8rem',
                    marginRight: '10px'
                  }}>
                    <div className="recommendation-title">
                      <span style={{ fontWeight: 'bold' }}>{recommendation.metadata.title}</span>
                    </div>
                    <div className="recommendation-description">
                      {recommendation.metadata.description}
                    </div>
                  </div>
                  <a
                    className="recommendation-icon"
                    href={`${recommendation.metadata.url}`}
                    target="_blank"
                    style={{
                      textDecoration: 'none',
                      color: 'teal',
                      width: "10%",
                      height: '100%',
                      display: 'flex',
                      justifyContent: 'end',
                      alignItems: 'center'
                    }}
                  >
                    <OpenInNewOutlined className="recommendation-icon" style={{
                      color: 'teal',
                      backgroundColor: '#D9E7E8',
                      borderRadius: '7px',
                      padding: '5px'
                    }} />
                  </a>
                </div>
              </li>
            ))}
          </ul>
        </div>
      )}
    </>
    </>
  );
};

export default Courses;
